export enum HubspotEvents {
	CUSTOMER_VIEWED_ACCELERATE_UPSELL = 'pe8815653_customer_viewed_accelerate_upsell',
	CUSTOMER_VIEWED_REVIEWS_UPSELL = 'pe8815653_customer_viewed_reviews_upsell',
	// Pickup & Delivery / Dispatch
	FS_PUD_DISPATCH_DASHBOARD = 'pe8815653_bm__fs___pud_dispatch_dashboard',
	FS_PUD_COMMERCIAL_CUSTOMERS = 'pe8815653_bm__fs___pud_commercial_customers',
	FS_PUD_COMMERCIAL_ORDERS = 'pe8815653_bm__fs___pud_commercial_orders',
	// Cents Assist
	FS_ASSIST_MESSENGER_ROOT = 'pe8815653_bm__fs___assist_messenger_root',
	FS_ASSIST_MESSENGER_INBOX = 'pe8815653_bm__fs___assist_messenger_inbox',
	FS_ASSIST_CALL_CENTER = 'pe8815653_bm__fs___assist_call_center',
	FS_ASSIST_CALL_CENTER_CALLS = 'pe8815653_bm__fs___assist_call_center_calls',
	FS_ASSIST_SETTINGS = 'pe8815653_bm__fs___assist_settings',
	FS_ASSIST_MESSENGER_NOTIFICATIONS = 'pe8815653_bm__fs___assist_messenger_notifications',
	// Accelerate / Marketing Tools
	FS_ACCELERATE_MARKETING_ROOT = 'pe8815653_bm__fs___accelerate_marketing_root',
	FS_ACCELERATE_PROMOTIONS_SETTINGS = 'pe8815653_bm__fs___accelerate_promotions_settings',
	FS_ACCELERATE_MARKETING_BLASTS = 'pe8815653_bm__fs___accelerate_marketing_blasts',
	FS_ACCELERATE_TASK_MANAGER = 'pe8815653_bm__fs___accelerate_task_manager',
	FS_ACCELERATE_REFERRAL_PROGRAM = 'pe8815653_bm__fs___accelerate_referral_program',
	FS_ACCELERATE_LOYALTY_PROGRAM = 'pe8815653_bm__fs___accelerate_loyalty_program',
}
